import { useQuery } from 'react-query'
import { fetchDevelopmentTracker, fetchTrackerStudents } from './service'
import type { FrameworkItem, TrackerStudent } from './types'
import { ALL_STUDENTS } from './types'

const STALE_TIME = 5 * 60 * 1000

interface UseTrackerStudentsReturn {
  readonly students: readonly TrackerStudent[]
  readonly isLoading: boolean
}

export const useTrackerStudents = (projectId: string | undefined, enabled: boolean): UseTrackerStudentsReturn => {
  const { data, isLoading } = useQuery(
    ['arc-tracker-students', projectId],
    () => fetchTrackerStudents(projectId as string),
    {
      enabled: Boolean(projectId) && enabled,
      staleTime: STALE_TIME,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  )

  return { students: data?.students ?? [], isLoading }
}

interface UseDevelopmentTrackerReturn {
  readonly items: readonly FrameworkItem[]
  readonly isLoading: boolean
  readonly isFetching: boolean
  readonly isError: boolean
}

export const useDevelopmentTracker = (
  projectId: string | undefined,
  studentId: string,
): UseDevelopmentTrackerReturn => {
  const param = studentId === ALL_STUDENTS ? undefined : studentId
  const { data, isLoading, isFetching, isError } = useQuery(
    ['arc-development-tracker', projectId, studentId],
    () => fetchDevelopmentTracker(projectId as string, param),
    {
      enabled: Boolean(projectId),
      staleTime: STALE_TIME,
      keepPreviousData: true,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  )

  return { items: data?.frameworkItems ?? [], isLoading, isFetching, isError }
}
